import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { QuotePageData } from '@cpak/adp-cpak-bff-service-models';
import { DialogOutletService } from './dialog-outlet';
import { OpenPropertiesModal } from '@cpak/interfaces';

@Injectable({
  providedIn: 'root',
})
export class PrototypePropertiesService extends DialogOutletService {
  private quoteData$ = new BehaviorSubject<QuotePageData | null>(null);
  private currencyLabel$ = new BehaviorSubject<string | null>(null);
  private quoteId = '';
  private navigateToPak = false;
  constructor(router: Router) {
    super(router, 'prototypeProperties');
  }

  public override onCloseModal(id = '', navigateToPak = false): void {
    this.navigateToPak = navigateToPak;
    this.quoteId = id;
    super.onCloseModal();
  }

  public onOpenPropertiesModal(config: OpenPropertiesModal): void {
    this.quoteId = '';
    this.currencyLabel$.next(config.currencyLabel || null);
    this.setQuoteData(config.quoteData || null);
    super.onOpenModal(config.id);
  }

  public override outletNavigation(activatedRoute: ActivatedRoute, outletStatus: string | null): void {
    super.outletNavigation(activatedRoute, outletStatus, './', false);
  }

  public getQuoteData(): Observable<QuotePageData | null> {
    return this.quoteData$.asObservable();
  }

  public getQuoteDataValue(): QuotePageData | null {
    return this.quoteData$.getValue();
  }

  public setQuoteData(data: QuotePageData | null): void {
    this.quoteData$.next(data);
  }

  public getCurrencyLabel(): string | null {
    return this.currencyLabel$.getValue();
  }

  public clearQuoteData(): void {
    this.quoteData$.next(null);
  }

  public cleanupData(): void {
    this.currencyLabel$.next(null);
    this.navigateToPak = false;
  }
}
